import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

/**
 * Converte valor vindo da API (date-only, ISO completo ou timestamp) em Date válido para o PrimeVue DatePicker.
 * Evita concatenação "…ZT00:00:00" quando Laravel já serializa {@see data_vencimento} como ISO 8601.
 */
function toJsDate(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    const s = String(value).trim();
    if (!s) {
        return null;
    }
    // Laravel Carbon JSON: "2026-04-25T00:00:00.000000Z" ou similar — não concatenar T00:00:00
    if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
        const d = new Date(s);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    // Apenas data "YYYY-MM-DD"
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const d = new Date(`${s}T12:00:00`);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
}

export default {
    parse(data) {
        ['pago', 'mensalidade', 'prorata'].forEach(item => {
            if (!data[item]){
                data[item] = 0;
            }
            else{
            data[item] = parseInt(data[item]);
            }
        });

        ['data_vencimento', 'data_pagamento'].forEach(item => {
            const d = toJsDate(data[item]);
            if (d) {
                data[item] = d;
            } else {
                data[item] = null;
            }
        });

        // Deriva tipo_conta a partir de mensalidade e prorata (somente para contas existentes)
        if (data.id) {
            if (data.mensalidade === 1) {
                data.tipo_conta = 'mensalidade';
            } else if (data.prorata === 1) {
                data.tipo_conta = 'prorata';
            } else {
                data.tipo_conta = 'avulso';
            }
        }
        // Para novas contas (sem id), tipo_conta permanece undefined/null

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/list${params}`, Token.getHeader());
    },
    listContas(contas, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/listContas/${contas}${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/conta/download${params}`, headers);
    },
    total(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/total${params}`, Token.getHeader());
    },
    valorTotal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/valor-total${params}`, Token.getHeader());
    },
    valorMensal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/valor-mensal${params}`, Token.getHeader());
    },
    tiposCobranca() {
        return axios.get('/api/conta/tipos-cobranca', Token.getHeader());
    },
    pagamentoRequisitos(params = '') {
        let query = '';
        if (params && typeof params === 'object') {
            query = '?' + new URLSearchParams(params).toString();
        } else if (typeof params === 'string' && params.length > 0) {
            query = params.startsWith('?') ? params : `?${params}`;
        }
        return axios.get(`/api/conta/pagamento-requisitos${query}`, Token.getHeader());
    },
    create(params) {
        return axios.post(`/api/conta`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/conta/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/conta/${id}`, Token.getHeader());
    },
    /**
     * Análise de boleto PDF via IA usando upload multipart (FormData com 'arquivo' + 'contrato_id').
     * Usado pelo FormTabArquivos.vue ao selecionar arquivo PDF na aba Arquivos do formulário de conta.
     */
    analisarBoletoPdf(formData) {
        const auth = Token.getHeader();
        return axios.post('/api/conta/analisar-boleto-pdf', formData, {
            ...auth,
            headers: {
                ...auth.headers,
                Accept: 'application/json',
            },
        });
    },
    /**
     * Análise de boleto via IA. Payload pode ser grande (Data URL); Accept JSON evita resposta HTML em erro de validação.
     */
    analyzeIA(params) {
        const auth = Token.getHeader();
        return axios.post(`/api/boletos/analyze-ia`, params, {
            ...auth,
            headers: {
                ...auth.headers,
                Accept: 'application/json',
            },
        });
    },
}
